// App
import type React from 'react';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import type { RootReduxState } from 'app/shared/flux/reducers';

// Components

// Misc / utils
import { filterUtils_getNumberOfActiveFilters } from 'app/shared/utils/filterUtils';
import * as S from './styles';

type AllFiltersButtonBaseProps = {
  ariaLabel?: string;
  ariaExpanded?: boolean;
  icon?: string;
  iconWidth?: string;
  iconHeight?: string;
  onClick?: () => void;
  customRef?: React.RefObject<HTMLButtonElement>;
};

const AllFiltersButtonBase = ({
  ariaLabel,
  ariaExpanded,
  icon,
  iconWidth,
  iconHeight,
  onClick,
  customRef,
}: AllFiltersButtonBaseProps) => {
  // Redux
  const filter = useSelector((state: RootReduxState) => state.filter);
  const screenWidth = useSelector((state: RootReduxState) => state.app.device.screenWidth);

  // React
  const [numActiveFilters, setNumActiveFilters] = useState<number>(0);

  useEffect(() => {
    let excludeFilters: Array<string> = ['commute'];
    if (screenWidth === 'sm' || screenWidth === 'lg' || screenWidth === 'xl') {
      excludeFilters = excludeFilters.concat(['price', 'bedrooms', 'pets', 'bathrooms']);
    }
    const num = filterUtils_getNumberOfActiveFilters(filter, excludeFilters as Array<never>);
    setNumActiveFilters(num);
  }, [filter, screenWidth]);

  return (
    <S.ButtonContainer
      ariaLabel={ariaLabel}
      ariaExpanded={ariaExpanded}
      active={numActiveFilters > 0}
      icon={numActiveFilters > 0 ? undefined : icon}
      iconWidth={iconWidth}
      iconHeight={iconHeight}
      onClick={onClick}
      ref={customRef}
    >
      {numActiveFilters > 0 && <S.NumFilterBadge>{numActiveFilters}</S.NumFilterBadge>}
      All filters
    </S.ButtonContainer>
  );
};

export default AllFiltersButtonBase;
